import http from "../shared/axios";
import { Get_Master_Data } from "../shared/ServiceCommonEndpoints";
let dataSet = {
  data: {
    cardType: null,
    cardChannelCode: null,
    cityList: "N",
    companyList: "N",
    bancaCityList: "N",
    designationList: "N",
    bankNameList: "N",
    branchNameList: null,
  },
  action: "submit",
  type: "Swift App"
};

class MasterDataService {
  funcGetEapplyData(payload) {
    let cityRequest = {
      ...dataSet,
      data: {
        ...dataSet.data,
        cardType: payload.cardType,
        cardChannelCode: payload.cardChannelCode,
        companyList: "Y",
        designationList: "Y"
      }
    };

    return http.post(
      Get_Master_Data,
      cityRequest,
      {
        headers: {
          "IDENTIFIER_1": localStorage.getItem("visitorID"),
          "IDENTIFIER_2": localStorage.getItem("anonymous_id")
        }
      }
    );
  }
  funcGetIFSCCodeList(bankData, cardListDetails) {
    let bankListRequest =
    {
      ...dataSet,
      data: {
        ...dataSet.data,
        cardType: cardListDetails.cardType,
        cardChannelCode: bankData.channelCode,
        branchNameList: {
          ifscCode: bankData?.ifscCode,
          bankName: bankData?.bank,
          bankCity: bankData?.city?.toUpperCase()
        },
      }
    }

    return http.post(
      Get_Master_Data,
      bankListRequest,
      {
        headers: {
          "IDENTIFIER_1": localStorage.getItem("visitorID"),
          "IDENTIFIER_2": localStorage.getItem("anonymous_id")
        }
      }
    );
  }
  funcGetCityByPinList(pin) {
    // let pinCodeList =[];
    let cityRequestbypin = {
      data: {
        pinCodeList: [
          pin
        ],
        action: "submit",
        type: "Swift App"
      }
    };

    return http.post(
      Get_Master_Data,
      cityRequestbypin
    );
  }
  /*
  funcGetCityList(payload) {
    let cityRequest = {
      ...dataSet,
      data: {
        ...dataSet.data,
        cardType: payload.cardType,
        cardChannelCode: payload.cardChannelCode,
        cityList: "Y"
      }
    };

    return http.post(
      Get_Master_Data,
      cityRequest,
      {
        headers: {
          "IDENTIFIER_1": localStorage.getItem("visitorID"),
          "IDENTIFIER_2": localStorage.getItem("anonymous_id")
        }
      }
    );
  }

  funcGetCompanyList(payload) {
    let companyRequest = {
      ...dataSet,
      data: {
        ...dataSet.data,
        cardType: payload.cardType,
        cardChannelCode: payload.cardChannelCode,
        companyList: "Y"
      }
    }

    return http.post(
      Get_Master_Data,
      companyRequest,
      {
        headers: {
          "IDENTIFIER_1": localStorage.getItem("visitorID"),
          "IDENTIFIER_2": localStorage.getItem("anonymous_id")
        }
      }
    );
  }

  funcGetBancaCityList(payload) {
    let bancaCityRequest = {
      ...dataSet,
      data: {
        ...dataSet.data,
        cardType: payload.cardType,
        cardChannelCode: payload.cardChannelCode,
        bancaCityList: "Y"
      }
    }

    return http.post(
      Get_Master_Data,
      bancaCityRequest,
      {
        headers: {
          "IDENTIFIER_1": localStorage.getItem("visitorID"),
          "IDENTIFIER_2": localStorage.getItem("anonymous_id")
        }
      }
    );
  }

  funcGetDesignationList(payload) {
    let designationRequest = {
      ...dataSet,
      data: {
        ...dataSet.data,
        cardType: payload.cardType,
        cardChannelCode: payload.cardChannelCode,
        designationList: "Y"
      }
    }

    return http.post(
      Get_Master_Data,
      designationRequest,
      {
        headers: {
          "IDENTIFIER_1": localStorage.getItem("visitorID"),
          "IDENTIFIER_2": localStorage.getItem("anonymous_id")
        }
      }
    );
  }

  funcGetBankList(payload) {
    let bankListRequest = {
      ...dataSet,
      data: {
        ...dataSet.data,
        cardType: payload.cardType,
        cardChannelCode: payload.cardChannelCode,
        bankNameList: "Y"
      }
    }

    return http.post(
      Get_Master_Data,
      bankListRequest,
      {
        headers: {
          "IDENTIFIER_1": localStorage.getItem("visitorID"),
          "IDENTIFIER_2": localStorage.getItem("anonymous_id")
        }
      }
    );
  }

  */
}
// eslint-disable-next-line
export default new MasterDataService();
